import {Box} from '@mui/material';
import {getBarColor} from '@jobseeker/lotus/utils';

type ProgressRingProps = {
  progress: number;
  radius: number;
  stroke: number;
};
const ProgressRing = ({radius, stroke, progress}: ProgressRingProps) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <Box
      component="svg"
      position="absolute"
      top="-12px"
      left="-6px"
      height={60}
      width={60}
      sx={{
        transform: 'rotate(-90deg)',
      }}
    >
      <circle
        stroke={getBarColor(progress)}
        fill="#e8effa"
        strokeWidth={stroke}
        strokeDasharray={circumference + ' ' + circumference}
        style={{strokeDashoffset}}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </Box>
  );
};

export default ProgressRing;
